<template>
  <div>
    <md-table  :value="stations" class="md-table-global-sales" @md-selected="onSelect">
      <md-table-toolbar v-if="title">
        <h1 class="md-title" v-text="title"></h1>
      </md-table-toolbar>
      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single" class="md-primary">
        <md-table-cell>{{ item.name }}</md-table-cell>
        <md-table-cell>{{ item.labour_request }}</md-table-cell>
        <md-table-cell>{{ item.labour_request }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
    name: 'station-request-table',
    props:{
        stations: { type: Array },
        title: { type: String, Default:'' },
    },
    data () {
        return {
            selected: {},
        };
    },
    methods:{
        async onSelect (item) {
            await this.$store.dispatch('dashboard/selected', item);
        }
    }
};
</script>
